import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  OverlayContainer,
  FrostBackdrop,
  Row,
  LandingTextWrapper,
  TextWrapper,
  Headline,
  Subheading,
} from "../styles/components/PLP/Global";
import gsap from "./Animations";
import { IS_TESTING } from "../config";

const Landing = props => {
  const wrapperRef = useRef(null);
  const headlineRef = useRef(null);
  const subheadingRef = useRef(null);

  const [blurAmount, setBlurAmount] = useState(0);

  const content = props[0].content;
  const headlines = content.filter(
    item => item.id && item.id.startsWith("DatoCmsHeadline")
  );

  const disableScrollHS = () => {
    let element = document.querySelector("#hs-web");
    if (element) {
      element.style.overflow = "hidden";
    } else {
      element = document.querySelector("#hs-app");
      if (element) {
        element.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "unset";
      }
    }
  };

  useEffect(() => {
    if (IS_TESTING) {
      disableScrollHS();
      document.querySelector(".gant--landing-section")?.classList.remove("active");
      gsap.to(".horizontal-scroll", { opacity: 1, duration: 0 });
      return;
    }

    window.scrollTo(0, 0);
    const timeline = gsap.timeline({});

    document.body.style.overflow = "hidden";

    gsap.set(wrapperRef.current, {
      transformOrigin: "top top",
    });

    const tween = gsap.to(
      {},
      {
        delay: 0.5,
        duration: 1.5,
        ease: "none",
        "--blur-amount": 0,
        "--blur-amount": 20,
        onUpdate: function () {
          setBlurAmount(this.targets()[0]["--blur-amount"]);
        },
      }
    );

    timeline
      .fromTo(
        headlineRef.current,
        {
          yPercent: 0,
          opacity: 0,
        },
        {
          delay: 0.5,
          duration: 1.5,
          yPercent: -100,
          opacity: 1,
          ease: "power4.out",
        }
      )
      .fromTo(
        subheadingRef.current.children,
        {
          yPercent: 0,
          opacity: 0,
        },
        {
          yPercent: -100,
          opacity: 1,
          stagger: 1,
          duration: 1,
          ease: "power4.out",
          delay: 0.25,
        }
      );

    timeline.then(() => {
      const tl = gsap.timeline({
        onComplete: () => {
          disableScrollHS();
          document
            .querySelector(".gant--landing-section")
            .classList?.remove("active");
          gsap.to(".horizontal-scroll", {
            opacity: 1,
            duration: 0,
          });
        },
      });
      tl.to(
        wrapperRef.current,
        {
          delay: 4,
          scaleY: 0,
          height: 1,
          duration: 1,
        },
        0
      );
    });
    return () => {
      tween.kill();
      timeline.kill();
    };
  }, []);

  return (
    <Container ref={wrapperRef}>
      <OverlayContainer>
        <FrostBackdrop $blurAmount={blurAmount}>
          <Row>
            {headlines.map(
              (headline, index) =>
                headline.text && (
                  <TextWrapper key={index}>
                    <Headline
                      ref={headlineRef}
                      dangerouslySetInnerHTML={{ __html: headline.text }}
                    />
                  </TextWrapper>
                )
            )}
            <LandingTextWrapper ref={subheadingRef}>
              <Subheading $margin>
                An American sportswear classic, GANT is diving deep into its own
                history by launching its own digital archive.
              </Subheading>
              <Subheading $margin>
                GANT's timeless and preppy aesthetic has made it synonymous with
                sophisticated yet comfortable fashion,
              </Subheading>
              <Subheading $margin>
                maintaining an iconic place in the Pantheon of Preppiness.
                <br></br>
                (Sponsored Story)
              </Subheading>
            </LandingTextWrapper>
          </Row>
        </FrostBackdrop>
      </OverlayContainer>
    </Container>
  );
};

export default Landing;
